import { call, put, takeEvery } from 'redux-saga/effects';
import {
  WIDGET_CONFIG_REQUEST,
  WIDGET_CONFIG_PREVIEW_REQUEST,
  UPDATE_WIDGET_CONFIG_REQUEST,
} from './actionTypes';
import {
  widgetConfigSuccess,
  widgetConfigFailure,
  widgetConfigPreviewSuccess,
  widgetConfigPreviewFailure,
  updateWidgetConfigSuccess,
  updateWidgetConfigFailure,
} from './actions';
import WidgetService from '../../services/WidgetService';

export function* getWidgetConfig(action) {
  try {
    const { dealerId } = action.payload;
    const widgetConfig = yield call(WidgetService.getConfig, dealerId);
    yield put(widgetConfigSuccess(widgetConfig));
  } catch (err) {
    yield put(widgetConfigFailure(err));
  }
}

export function* getWidgetConfigPreview(body) {
  try {
    const payload = body.payload;
    const widgetConfig = yield call(WidgetService.getConfigPreview, payload);
    yield put(widgetConfigPreviewSuccess(widgetConfig));
  } catch (err) {
    yield put(widgetConfigPreviewFailure(err));
  }
}

export function* updateWidgetConfig(action) {
  try {
    const widgetConfig = yield call(
      WidgetService.updateConfig,
      action.payload.dealerId,
      action.payload.widgetConfig,
    );
    yield put(updateWidgetConfigSuccess(widgetConfig));
  } catch (err) {
    yield put(updateWidgetConfigFailure(err));
  }
}

export function* widgetsSaga() {
  yield takeEvery(WIDGET_CONFIG_REQUEST, getWidgetConfig);
  yield takeEvery(WIDGET_CONFIG_PREVIEW_REQUEST, getWidgetConfigPreview);
  yield takeEvery(UPDATE_WIDGET_CONFIG_REQUEST, updateWidgetConfig);
}
